import * as React from 'react';
export const samsungpaySvg = React.forwardRef(function samsungpaySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3.809 7.934V6.415h.586a.773.773 0 0 1 .553.22.7.7 0 0 1 .159.24.777.777 0 0 1 .056.297.772.772 0 0 1-.215.539.714.714 0 0 1-.243.164.798.798 0 0 1-.31.059H3.81Zm4.42 1.12a1.04 1.04 0 0 1-.396.074 1.041 1.041 0 0 1-.712-.277.957.957 0 0 1-.288-.686c0-.134.026-.26.076-.377a.903.903 0 0 1 .212-.302 1.036 1.036 0 0 1 .712-.275c.143 0 .275.025.395.075a.907.907 0 0 1 .31.203.958.958 0 0 1-.31 1.565Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M14.098 1.913c.91.968 1.427 2.29 1.62 3.75.185 1.394.14 2.343.14 2.343s.046.948-.14 2.342c-.193 1.46-.71 2.782-1.62 3.75-.969.911-2.29 1.428-3.75 1.621-1.394.184-2.343.14-2.343.14s-.949.046-2.342-.14c-1.46-.193-2.782-.71-3.75-1.62-.911-.97-1.428-2.291-1.621-3.75-.184-1.395-.14-2.343-.14-2.343s-.046-.95.14-2.343c.193-1.46.71-2.782 1.62-3.75.969-.91 2.291-1.427 3.75-1.621C7.057.108 8.006.153 8.006.153s.949-.046 2.343.139c1.46.194 2.781.71 3.75 1.621ZM4.45 5.703H3.04v4.119h.768v-1.18h.637a1.51 1.51 0 0 0 1.066-.427 1.491 1.491 0 0 0 .422-1.044 1.447 1.447 0 0 0-.89-1.352 1.51 1.51 0 0 0-.593-.115Zm2.67 4.016c.193.074.39.11.59.11.217 0 .42-.041.608-.126.188-.084.343-.2.463-.348v.47h.763V6.52H8.78v.435a1.268 1.268 0 0 0-.457-.323 1.523 1.523 0 0 0-.604-.118 1.72 1.72 0 0 0-.606.112 1.583 1.583 0 0 0-.525.325 1.607 1.607 0 0 0-.366.519 1.706 1.706 0 0 0-.14.704c0 .261.049.494.143.7a1.6 1.6 0 0 0 .894.843Zm2.672-3.196 1.354 3.159-.695 1.66h.774l1.969-4.819h-.801l-.87 2.258-.919-2.258h-.812Z',
      clipRule: 'evenodd',
    }),
  );
});
samsungpaySvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var samsungpay = {
  category: 'paymentmethod',
  colorable: true,
  name: 'samsungpay',
  svg: samsungpaySvg,
};
